import { useIntl } from 'react-intl'

import Box from 'app/components/base/Box'
import { USER_ROLE } from 'app/utils/constants/role.constants'

import ReportListingBlock from '../components/ReportListingBlock'
import { formatDimensions } from '../helpers/listing.helpers'

import {
  AdditionalInfo,
  Collapse,
  Description,
  PaymentInfo,
  ShippingReturnRules
} from './ListingDynamicComponents'

interface ListingInformationProps {
  listing: ListingModel
  isPreview?: boolean
  loading?: boolean
  isAuthUserListing?: boolean
  paymentGateways?: PaymentGatewayModel[]
}

const ListingInformation: RFC<ListingInformationProps> = ({
  isPreview,
  listing,
  loading,
  isAuthUserListing = false,
  paymentGateways
}) => {
  const { formatMessage } = useIntl()
  const {
    shipping,
    category_options,
    user: seller,
    currency: listingCurrency
  } = listing || {}

  const { dimensions, formattedWeight } = formatDimensions(
    shipping,
    formatMessage
  )

  const hideReportBlock = isPreview || isAuthUserListing
  const isPersonalSeller = seller?.role === USER_ROLE.PERSONAL

  return (
    <Box>
      <Collapse open title={formatMessage({ defaultMessage: 'Details' })}>
        <Description
          description={listing?.description}
          shipping={listing?.shipping}
          subCategory={listing?.sub_category}
          year={listing?.year}
          dimensions={dimensions}
          weight={formattedWeight}
          package_name={shipping?.package_name}
          loading={loading}
          categoryOptions={category_options}
          compatibilities={listing?.compatibilities}
          partNumber={listing?.part_number}
        />
      </Collapse>

      <Collapse
        title={formatMessage({
          defaultMessage: 'Condition, Warranty & Type Info'
        })}
      >
        <AdditionalInfo
          condition={listing?.condition}
          warranty={listing?.warranty_valid_until}
          itemType={listing?.item_type}
        />
      </Collapse>

      <Collapse title={formatMessage({ defaultMessage: 'Shipping & Returns' })}>
        <ShippingReturnRules
          isPreview={isPreview}
          shippingType={shipping?.shipping_types}
          packaging={shipping?.package_name}
          weight={formattedWeight}
          slug={listing?.slug}
          shippingPolicyInfo={listing?.user?.shipping_policy_info}
          isAuthUserListing={isAuthUserListing}
          shipping={shipping}
          collectionTimeFrames={listing?.collection_time_frames}
          isPersonalSeller={isPersonalSeller}
          ownShippingCurrency={listingCurrency?.name}
        />
      </Collapse>

      <Collapse title={formatMessage({ defaultMessage: 'Payment Info' })}>
        <PaymentInfo paymentGateways={paymentGateways} />
      </Collapse>

      <ReportListingBlock
        listingId={listing?.id}
        loading={loading}
        hideBlock={hideReportBlock}
      />
    </Box>
  )
}

export default ListingInformation
